<template>
  <div class="vertical-center">
    <a :href="'/device/request-devices/' + this.params.value">{{this.params.value}}</a>
  </div>
</template>

<script>
  import Vue from "vue";

  export default Vue.extend({
    name: 'DeviceRequestDetail',
    data() {
      return {
        value: ''
      }
    },
    mounted() {
    }
  })
</script>

<style scoped>
  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
  .padding-x-05 {
    padding-left: 0.5em!important;
    padding-right: 0.5em!important;
  }
</style>

